import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-view-test-report-guide-note',
  templateUrl: './view-test-report-guide-note.component.html',
  styleUrls: ['./view-test-report-guide-note.component.css']
})
export class ViewTestReportGuideNoteComponent implements OnInit {

  @Input() testType: any;
  constructor() { }

  ngOnInit(): void {
  }

}
